import _ from 'underscore';
import tinycolor from 'tinycolor2';
import events from 'girder/events';
import Panel from 'girder_plugins/slicer_cli_web/views/Panel';

import StyleCollection from '../collections/StyleCollection';
import StyleModel from '../models/StyleModel';
import editElement from '../dialogs/editElement';
import editStyleGroups from '../dialogs/editStyleGroups';
import drawWidget from '../templates/panels/drawWidget.pug';
import '../stylesheets/panels/drawWidget.styl';
import '../stylesheets/body/common.styl';
import {
    restRequest
} from 'girder/rest';
/**
 * Create a panel with controls to draw and edit
 * annotation elements.
 */
// Variable used for not allowing drawing type to be not active when annotations are transferred/edited to different groups.
var transfer = false;
//To retain sorting value even after transfer of annotations
var ascsorting = false;
var descsorting = false;
var sortWay;
var activeElement = '';

var DrawWidget = Panel.extend({
    events: _.extend(Panel.prototype.events, {
        'click .h-edit-element': 'editElement',
        'click .h-delete-element': 'deleteElement',
        'click .h-draw': 'drawElement',
        'change .h-style-group': '_setStyleGroup',
        'click .h-configure-style-group': '_styleGroupEditor',
        'mouseenter .h-element': '_highlightElement',
        'mouseleave .h-element': '_unhighlightElement',
        'click .h-element': '_focusAnnotation',
        'click .h-sort-asc-annotation': 'sortByAscAnnotations',
        'click .h-sort-desc-annotation': 'sortByDescAnnotations',
        'click .line-width p': 'getLineWidth',
        'click .h-prev-annotation': 'getPrevAnnotation',
        'click .h-next-annotation': 'getNextAnnotation'
    }),

    /**
     * Create the panel.
     *
     * @param {object} settings
     * @param {ItemModel} settings.image
     *     The associate large_image "item"
     */
    initialize(settings) {
        this.groupName = 'default';
        this.easy_annotation = settings.easy_annotation || false;
        this.getSettings();
        this.image = settings.image;
        this.annotation = settings.annotation;
        this.annotationSelector = settings.annotationSelector;
        this.contextMenu = settings.contextMenu;
        this.collection = this.annotation.elements();
        this.viewer = settings.viewer;
        this.setViewer(settings.viewer);
        this._drawingType = settings.drawingType || null;

        this._highlighted = {};
        this._groups = new StyleCollection();
        this._style = new StyleModel({
            id: 'default'
        });
        this.listenTo(this._groups, 'update', this.render);
        this.listenTo(this.collection, 'add remove reset', this._recalculateGroupAggregation);
        this.listenTo(this.collection, 'change update reset', this.render);
        this._groups.fetch().done(() => {
            // ensure the default style exists
            if (this._groups.has('default')) {
                this._style.set(this._groups.get('default').toJSON());
            } else {
                this._groups.add(this._style.toJSON());
                this._groups.get(this._style.id).save();
            }
        });
        this.on('h:mouseon', (model) => {
            if (model && model.id) {
                this._highlighted[model.id] = true;
                this.$(`.h-element[data-id="${model.id}"]`).addClass('h-highlight-element');
                var element_position = 0;
                if (this.$(`.h-element[data-id="${model.id}"]`) && this.$(`.h-element[data-id="${model.id}"]`)[0]) {
                    element_position = this.$(`.h-element[data-id="${model.id}"]`)[0].offsetTop;
                }
                var parent_div = $(`#h-elements-container`);
                var container_position = parent_div[0] ? parent_div[0].offsetTop : 0;
                if (element_position >= container_position) {
                    parent_div.scrollTop(element_position - container_position);
                } else {
                    parent_div.scrollTop(0);
                }
            }
        });
        this.on('h:mouseoff', (model) => {
            if (model && model.id) {
                this._highlighted[model.id] = false;
                this.$(`.h-element[data-id="${model.id}"]`).removeClass('h-highlight-element');
            }
        });
        this.lineWidthValue = this._style.get('lineWidth');
        this.lineWidthName = this.lineWidthValue + ' px';
        //this.createAnnotationStyles();
    },

    getSettings() {
        restRequest({
            url: `HistomicsTK/settings`
        }).then((settings) => {
            this.easy_annotation = settings['histomicstk.easy_annotation'];
        });
    },

    render() {
        this.$('.h-colorpicker').colorpicker('destroy');
        this.$('[data-toggle="tooltip"]').tooltip('destroy');
        if (!this.viewer) {
            this.$el.empty();
            return;
        }
        const name = (this.annotation.get('annotation') || {}).name || 'Untitled';
        if (this.annotation.get('groups') && this._groups.get(this.annotation.get('groups')[0]) && this.annotation.get('groups')[0] != null) {
            this.groupName = this.annotation.get('groups')[0];
        } else if (this.annotation.get('groupName')) {
            this.groupName = this.annotation.get('groupName');
        }
        this.trigger('h:redraw', this.annotation);
        // To retain sorting in draw widget after annotations transfer
        if (ascsorting && sortWay != undefined && sortWay == 'asc') {
            this.sortByAscAnnotations();
        } else if (descsorting && sortWay != undefined && sortWay == 'desc') {
            this.sortByDescAnnotations();
        }
        //sortBy: sortWay to be used in below,
        this.$el.html(drawWidget({
            title: 'Draw',
            elements: this.collection.models,
            groups: this._groups,
            style: this._style.id,
            highlighted: this._highlighted,
            groupName: this.groupName,
            name,
            sortBy: sortWay,
            easyAnnotation: this.easy_annotation,
            model: new StyleModel(this._style.toJSON()),
            lineWidthName: this.lineWidthName
        }));
        if (activeElement != '') {
            $("[data-id='" + activeElement + "']").addClass('h-active-element');
        }
        this._setStyleGroup();
        if (this._drawingType) {
            this.$('button.h-draw[data-type="' + this._drawingType + '"]').addClass('active');
            this.drawElement(undefined, this._drawingType);
        }
        this.$('.s-panel-content').collapse({
            toggle: false
        });
        this.$('[data-toggle="tooltip"]').tooltip({
            container: 'body'
        });
        if (this.viewer.annotationLayer && !this.viewer.annotationLayer._boundHistomicsTKModeChange) {
            this.viewer.annotationLayer._boundHistomicsTKModeChange = true;
            this.viewer.annotationLayer.geoOn(window.geo.event.annotation.mode, (event) => {
                this.$('button.h-draw').removeClass('active');
                if (this._drawingType) {
                    this.$('button.h-draw[data-type="' + this._drawingType + '"]').addClass('active');
                }
                //Condition to check if the annotation is moved/edited to different group
                if (event.mode !== this._drawingType && this._drawingType && !transfer) {
                    transfer = false;
                    /* This makes the draw modes stay on until toggled off.
                     * To turn off drawing after each annotation, add
                     *  this._drawingType = null;
                     */
                    this.drawElement(undefined, this._drawingType);
                }
            });
        }
        this.$('.h-colorpicker').colorpicker();
        return this;
    },

    /**
     * When a region should be drawn that isn't caused by a drawing button,
     * toggle off the drawing mode.
     *
     * @param {event} Girder event that triggered drawing a region.
     */
    _widgetDrawRegion(evt) {
        this._drawingType = null;
        this.$('button.h-draw').removeClass('active');
    },

    /**
     * Set the image "viewer" instance.  This should be a subclass
     * of `large_image/imageViewerWidget` that is capable of rendering
     * annotations.
     */
    setViewer(viewer) {
        this.viewer = viewer;
        // make sure our listeners are in the correct order.
        this.stopListening(events, 's:widgetDrawRegion', this._widgetDrawRegion);
        if (viewer) {
            this.listenTo(events, 's:widgetDrawRegion', this._widgetDrawRegion);
            viewer.stopListening(events, 's:widgetDrawRegion', viewer.drawRegion);
            viewer.listenTo(events, 's:widgetDrawRegion', viewer.drawRegion);
        }
        return this;
    },

    /**
     * Respond to a click on the "edit" button by rendering
     * the EditAnnotation modal dialog.
     */
    editElement(evt) {
        editElement(this.collection.get(this._getId(evt)), null, this.collection, this.image.id, this.annotation, this.annotationSelector, this.contextMenu);
        this.clearElement();
    },

    // To clear drawing type
    clearElement() {
        transfer = true;
        this._drawingType = null;
        this.viewer.annotationLayer.mode(null);
        this.viewer.annotationLayer.geoOff(window.geo.event.annotation.state);
        this.viewer.annotationLayer.removeAllAnnotations();
    },

    /**
     * Respond to a click on the "delete" button by removing
     * the element from the element collection.
     */
    deleteElement(evt) {
        this.collection.remove(this._getId(evt));
    },

    /**
     * Respond to clicking an element type by putting the image
     * viewer into "draw" mode.
     *
     * @param {jQuery.Event} [evt] The button click that triggered this event.
     *      `undefined` to use a passed-in type.
     * @param {string|null} [type] If `evt` is `undefined`, switch to this draw
     *      mode.
     */
    drawElement(evt, type) {
        var $el;
        if (evt) {
            $el = this.$(evt.currentTarget);
            $el.tooltip('hide');
            type = $el.hasClass('active') ? null : $el.data('type');
        } else {
            $el = this.$('button.h-draw[data-type="' + type + '"]');
        }
        if (this.viewer.annotationLayer.mode() === type && this._drawingType === type) {
            return;
        }
        if (this.viewer.annotationLayer.mode()) {
            this._drawingType = null;
            this.viewer.annotationLayer.mode(null);
            this.viewer.annotationLayer.geoOff(window.geo.event.annotation.state);
            this.viewer.annotationLayer.removeAllAnnotations();
        }
        if (type) {
            // always show the active annotation when drawing a new element
            this.annotation.set('displayed', true);

            this._drawingType = type;
            this.viewer.startDrawMode(type)
                .then((element) => {
                    this.saveStyle();
                    if (element[0].type == 'polyline' && !element[0].closed) {
                        let numPoints = element[0].points.length;
                        let p1 = element[0].points[0];
                        let p2 = element[0].points[numPoints - 1];
                        let x1 = p1[0];
                        let y1 = p1[1];
                        let x2 = p2[0];
                        let y2 = p2[1];
                        element[0].points.splice(1, numPoints - 2);
                        restRequest({
                            url: `item/${this.image.id}/tiles`
                        }).then((items) => {
                            let mmx = items.mm_x;
                            let mmy = items.mm_y;
                            let dfx = (x2 - x1) * mmx;
                            let dfy = (y2 - y1) * mmy;
                            let lineLength = Math.sqrt(Math.pow(dfx, 2) + Math.pow(dfy, 2));
                            lineLength = lineLength.toFixed(4);
                            var line_element = _.map(element, (el) => _.extend(el, _.omit(this._style.toJSON(), 'id')));
                            if (line_element[0].label && line_element[0].label.value) {
                                line_element[0].label = {
                                    value: this._style.attributes.label.value + ' : ' + lineLength + ' mm'
                                }
                            } else {
                                line_element[0].label = {
                                    value: 'line : ' + lineLength + ' mm'
                                }
                            }
                            this.collection.add(line_element);
                        });
                    } else if (element[0].type == 'polyline' && element[0].closed) {
                        var area = 0;
                        var vertices = element[0].points;
                        var j = vertices.length - 1;
                        for (var i = 0; i < vertices.length; i++) {
                            area += (vertices[j][0] + vertices[i][0]) * (vertices[j][1] - vertices[i][1]);
                            j = i;
                        }
                        area = area/2;                        
                        restRequest({
                            url: `item/${this.image.id}/tiles`
                        }).then((items) => {
                            let mmx = items.mm_x;
                            let mmy = items.mm_y;
                            area = (area * mmx * mmy).toFixed(4);
                            area = Math.abs(area);
                            var polygon_element = _.map(element, (el) => _.extend(el, _.omit(this._style.toJSON(), 'id')));
                            if (polygon_element[0].label && polygon_element[0].label.value) {
                                polygon_element[0].label = {
                                    value: this._style.attributes.label.value + ' : ' + area + ' mm'
                                }
                            } else {
                                polygon_element[0].label = {
                                    value: 'polygon : ' + area + ' mm'
                                }
                            }
                            this.collection.add(polygon_element);
                        });
                    } else {
                        this.collection.add(
                            _.map(element, (el) => _.extend(el, _.omit(this._style.toJSON(), 'id')))
                        );
                    }
                    restRequest({
                        url: `HistomicsTK/settings`
                    }).then((settings) => {
                        if (settings['histomicstk.easy_annotation']) {
                            editElement(this.collection.get(element[0].id), true);
                        }
                    });
                    return undefined;
                });
        }
    },

    cancelDrawMode() {
        this.drawElement(undefined, null);
        this.viewer.annotationLayer._boundHistomicsTKModeChange = false;
        this.viewer.annotationLayer.geoOff(window.geo.event.annotation.state);
    },

    drawingType() {
        return this._drawingType;
    },

    /**
     * Get the element id from a click event.
     */
    _getId(evt) {
        return this.$(evt.currentTarget).parent('.h-element').data('id');
    },

    _setStyleGroup() {
        this.groupName = this.$('.h-style-group').val();
        if (this._groups.get(this.$('.h-style-group').val())) {
            if (this._style.get('group')) {
                delete this._style['attributes']['group'];
            }
            this._style.set(
                this._groups.get(this.$('.h-style-group').val()).toJSON()
            );
        }
        if (!this._style.get('group') && this._style.id !== 'default') {
            this._style.set('group', this._style.id);
        }
    },

    _styleGroupEditor() {
        var dlg = editStyleGroups(this._style, this._groups);
        dlg.$el.on('hidden.bs.modal', () => {
            this.render();
            this.parentView.trigger('h:styleGroupsEdited', this._groups);
        });
    },

    _focusAnnotation(evt) {
        const id = $(evt.currentTarget).data('id');
        activeElement = id;
        this.parentView.trigger('h:focusAnnotation', this.annotation.attributes.annotation, id);
    },

    _highlightElement(evt) {
        const id = $(evt.currentTarget).data('id');
        this.parentView.trigger('h:highlightAnnotation', this.annotation.id, id);
    },

    _unhighlightElement() {
        this.parentView.trigger('h:highlightAnnotation');
    },

    _recalculateGroupAggregation() {
        const groups = _.invoke(
            this.collection.filter((el) => el.get('group')),
            'get', 'group'
        );
        this.annotation.set('groups', groups);
    },

    createAnnotationStyles() {
        restRequest({
            url: `item/${this.image.id}`
        }).then((items) => {
            if (items.baseParentType === 'collection') {
                restRequest({
                    url: `/folder?parentType=collection&parentId=${items.baseParentId}`
                }).then((collection) => {
                    let meta = collection.find(c => c.name == 'meta');
                    if (meta) {
                        restRequest({
                            url: `/item?folderId=${meta._id}`
                        }).then((data) => {
                            let jsonData = data.find(d => d.name == 'annotation_styles.json');
                            if (jsonData) {
                                restRequest({
                                    url: `/item/${jsonData._id}/download?contentDisposition=inline`
                                }).then((styles) => {
                                    styles.forEach(style => {
                                        if (this._groups.has(style.id)) {
                                            this._groups.get(style.id).set(style).save()
                                        } else {
                                            this._annotationStyles = new StyleModel(style);
                                            this._groups.add(this._annotationStyles.toJSON());
                                            this._groups.get(this._annotationStyles.id).save();
                                        }
                                    });
                                    this._groups.remove('default');
                                });
                            }
                        });
                    }
                });
            }
        });
    },

    _getAnnotationLabel(annotation) {
        var label_anno = (annotation.attributes.label && annotation.attributes.label.value) ?
            annotation.attributes.label.value :
            (annotation.attributes.type == 'polyline' ?
                (annotation.attributes.closed ? 'polygon' : 'line') :
                annotation.attributes.type
            );
        return label_anno.toLowerCase();
    },

    sortByAscAnnotations(evt) {
        if (this.collection.models.length > 1) {
            this.sortBy = 'asc';
            sortWay = 'asc';
            this.collection.models.sort((a, b) => {
                var label_a = this._getAnnotationLabel(a);
                var label_b = this._getAnnotationLabel(b);
                return (label_a > label_b) ? 1 : (label_a < label_b) ? -1 : 0;
            });
            //To call render only when clicked on sorting buttons and not on transfer
            if (!ascsorting || evt != undefined) {
                ascsorting = true;
                this.render();
                events.trigger('h:sortDraw', this.sortBy);
            }
        }
    },

    sortByDescAnnotations(evt) {
        if (this.collection.models.length > 1) {
            this.sortBy = 'desc';
            sortWay = 'desc';
            this.collection.models.sort((a, b) => {
                var label_a = this._getAnnotationLabel(a);
                var label_b = this._getAnnotationLabel(b);
                return (label_a > label_b) ? -1 : (label_a < label_b) ? 1 : 0;
            });
            if (!descsorting || evt != undefined) {
                descsorting = true;
                this.render();
                events.trigger('h:sortDraw', this.sortBy);
            }
        }
    },

    getLineWidth(evt){
        var lineWidthValue = $(evt.target)[0].innerText;
        this.lineWidthName = lineWidthValue + ' px';
        this.lineWidthValue = lineWidthValue;
        $('#h-element-line-width').val(lineWidthValue);
        $('.line-width-value').text(this.lineWidthName);
    },

    convertColor(val) {
        if (!val) {
            return 'rgba(0,0,0,0)';
        }
        return tinycolor(val).toRgbString();
    },

    saveStyle(evt) {
        const data = {};
        const lineWidth = this.$('#h-element-line-width').val();
        if (lineWidth) {
            data.lineWidth = parseFloat(lineWidth);
            if (data.lineWidth < 0 || !isFinite(data.lineWidth)) {
                validation = 'Invalid line width. ';
                this.$('#h-element-line-width').parent().addClass('has-error');
            }
        }
        const lineColor = this.$('#h-element-line-color').val();
        if (lineColor) {
            data.lineColor = this.convertColor(lineColor);
        }
        const fillColor = this.$('#h-element-fill-color').val();
        if (fillColor) {
            data.fillColor = this.convertColor(fillColor);
        }
        this._style.set(data);
        this._style.set(new StyleModel(this._style.toJSON()).toJSON());
        this._groups.add(new StyleModel(this._style.toJSON()).toJSON(), {
            merge: true
        });
        this._groups.get(this._style.id).save();
    },

    getPrevAnnotation() {
        var isInCollection = this.collection.models.find(a => a.id == activeElement);
        if (isInCollection == undefined) {
            activeElement = '';
        }
        if (activeElement != '') {
            var element = $("[data-id='" + activeElement + "']");
            $('.h-element').removeClass('h-active-element');
            if (element.prev().length > 0) {
                element.prev().addClass('h-active-element');
                element.prev().click();
            } else {
                $('.h-element:last').addClass('h-active-element');
                $('.h-element:last').click();
            }
        } else {
            $('.h-element').removeClass('h-active-element');
            $('.h-element:last').addClass('h-active-element');
            $('.h-element:last').click();
        }
    },

    getNextAnnotation() {
        var isInCollection = this.collection.models.find(a => a.id == activeElement);
        if(isInCollection == undefined){
            activeElement = '';
        }
        if (activeElement != '') {
            var element = $("[data-id='" + activeElement + "']");
            $('.h-element').removeClass('h-active-element');
            if (element.next().length > 0) {
                element.next().addClass('h-active-element');
                element.next().click();
            } else {
                $('.h-element:first').addClass('h-active-element');
                $('.h-element:first').click();
            }
        } else {
            $('.h-element').removeClass('h-active-element');
            $('.h-element:first').addClass('h-active-element');
            $('.h-element:first').click();
        }
    }
});

export default DrawWidget;



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/panels/DrawWidget.js